import { Navigate, createBrowserRouter } from 'react-router-dom'
import { AppLayout } from '@/components/layout/app-layout'
import { ProtectedRoute } from './protected-route'
import { LoginPage } from '@/pages/login'
import { DashboardPage } from '@/pages/dashboard'
import { ProjectNewPage } from '@/pages/project-new'
import { LegacyProjectRedirect, ProjectDetailPage } from '@/pages/project-detail'
import { InventoryPage } from '@/pages/inventory'
import { SettingsPage } from '@/pages/settings'
import { SettingsProfilePage } from '@/pages/settings-profile'
import { ProfilePage } from '@/pages/profile'
import { BrowsePage } from '@/pages/browse'
import { CommunityDirectoryPage } from '@/pages/community-directory'
import { CommunityBrowsePage } from '@/pages/community-browse'
import { CommunityAboutPage } from '@/pages/community-about'
import { CommunityNewPage } from '@/pages/community-new'
import { AdminSeedReviewPage } from '@/pages/admin-seed-review'
import { NotificationsPage } from '@/pages/notifications'
import { NotFoundPage } from '@/pages/not-found'

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    // Phase 6: canonical Project URL — /p/:handle/:slug. Public route; visibility enforced server-side.
    path: '/p/:handle/:slug',
    element: <AppLayout />,
    children: [{ index: true, element: <ProjectDetailPage /> }],
  },
  {
    // Phase 6: legacy /projects/:id soft-redirects to canonical via router.replace. Existing
    // Phase 1–5 link shares keep working; the address bar updates to canonical form.
    path: '/projects/:id',
    element: <AppLayout />,
    children: [{ index: true, element: <LegacyProjectRedirect /> }],
  },
  {
    // Public route: anonymous users can view profiles + their public projects.
    path: '/u/:handle',
    element: <AppLayout />,
    children: [{ index: true, element: <ProfilePage /> }],
  },
  {
    // Public route: anonymous users can browse + search public projects.
    path: '/browse',
    element: <AppLayout />,
    children: [{ index: true, element: <BrowsePage /> }],
  },
  {
    // Phase 19: communities (subapps). Anonymous read; signed-in create/join.
    path: '/c',
    element: <AppLayout />,
    children: [{ index: true, element: <CommunityDirectoryPage /> }],
  },
  {
    path: '/c/:slug',
    element: <AppLayout />,
    children: [{ index: true, element: <CommunityBrowsePage /> }],
  },
  {
    path: '/c/:slug/about',
    element: <AppLayout />,
    children: [{ index: true, element: <CommunityAboutPage /> }],
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/browse" replace />,
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'projects/new',
        element: <ProjectNewPage />,
      },
      {
        path: 'communities/new',
        element: <CommunityNewPage />,
      },
      {
        // Phase 19 admin surface — backend gates by handle list.
        path: 'admin/seed-review',
        element: <AdminSeedReviewPage />,
      },
      {
        path: 'me/inventory',
        element: <InventoryPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
      {
        path: 'settings/profile',
        element: <SettingsProfilePage />,
      },
      {
        path: 'notifications',
        element: <NotificationsPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
])
